import React, { createContext, useContext, useState, useMemo, useEffect } from "react";

const PersonaCtx = createContext(null);

const PERSONAS = [
    { id: "developer", label: "DEV", full: "Developer" },
    { id: "enterprise", label: "ENT", full: "Enterprise" },
    { id: "investor", label: "INV", full: "Investor" },
    { id: "researcher", label: "RSR", full: "Researcher" },
];

export function PersonaProvider({ children }) {
    const [persona, setPersona] = useState(() => localStorage.getItem("apib_persona") || "developer");
    const [soundOn, setSoundOn] = useState(false);
    useEffect(() => { localStorage.setItem("apib_persona", persona); }, [persona]);
    const value = useMemo(() => ({ persona, setPersona, soundOn, setSoundOn, PERSONAS }), [persona, soundOn]);
    return <PersonaCtx.Provider value={value}>{children}</PersonaCtx.Provider>;
}

export function usePersona() {
    return useContext(PersonaCtx);
}

export { PERSONAS };
